// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2bw3c","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1z5KF"};